import styled from "@emotion/styled/macro";
import React, { Fragment } from "react";

import { Spacer } from "Components/Common/Spacer/index";
import {
  FlexWrapperT2,
  FlexWrapperT4,
  FlexWrapperT6,
} from "Components/Common/Wrapper/FlexWrapper";
import {
  TypographyT13,
  TypographyT17,
  TypographyT33,
  TypographyT34,
} from "Components/Common/Typography/index";
import RateInfoCard from "./RateInfoCard";
import { Wrapper } from "Components/Common/Wrapper/index";
import { LabelT2 } from "Components/Common/Label/index";
import SelectT1 from "Components/Common/Select/SelectT1";
import Message from "Components/Common/Message/Message";
import { CardT1Wrapper } from "Components/Common/Card/index";
import PaginationButtons from "./PaginationButtons";
const options = [
  { value: "Lucknow", label: "Lucknow" },
  { value: "All", label: "All" },
  { value: "Mundra", label: "Mundra" },
];
const FreightDetails = (props) => {
  const {
    viewDetailsRoadFreight,
    freightDays,
    avgFreight,
    handleOnChangeAvgFreight,
    vehicleDetails,
    vehicleType,
    handleOnChangeVehicleType,
    handleOnClickForVehicleName,
    handleOnClickRFRPreviousPage,
    handleOnClickRFRNextPage
  } = props;

  const shouldRenderTable = () => {
    const C1 = viewDetailsRoadFreight.length > 0;
    if (C1) {
      return true;
    }
    return false;
  };

  return (
    <Fragment>
      <FreightDetailsWrapper>
        <FlexWrapperT2>
          <TypographyT33>Road Freight</TypographyT33>
            <PaginationButtons
                handleOnClickNextPage={handleOnClickRFRNextPage}
                handleOnClickPreviousPage={handleOnClickRFRPreviousPage}
              />
        </FlexWrapperT2>
        <Spacer spacing={"5px 0px"} />
        <FlexWrapperT6>
          {viewDetailsRoadFreight.length === 0 && <Message />}
          {shouldRenderTable() && (
            <TableWrapper>
              <Table>
                <THead>
                  <Tr>
                    {viewDetailsRoadFreight.map((ele, ind) => {
                      return (
                        <Fragment key={ind}>
                          <Th>
                            <TypographyT13>{`${ele.from} - ${ele.to}`}</TypographyT13>
                          </Th>
                        </Fragment>
                      );
                    })}
                  </Tr>
                </THead>
                <TBody>
                  <Tr>
                    {viewDetailsRoadFreight.map((ele, ind) => {
                      return (
                        <Fragment key={ind}>
                          <RateInfoCardT1
                            isActive={false}
                            isLActive={ele.rate_order_text === "L1"}
                            rate={ele.sum_of_bid_price}
                            labelOfL={ele.rate_order_text}
                            labelOne={`TAT - ${ele.tat.value} ${ele.tat.name}`}
                            shouldRenderVehicleName = {true}
                            vehicleName = {ele.vehicle_type_name || '-'}
                            handleOnClickForVehicleName = {()=>{
                              handleOnClickForVehicleName(ele)
                            }}
                          />
                        </Fragment>
                      );
                    })}
                  </Tr>
                </TBody>
              </Table>
            </TableWrapper>
          )}
          {/* <Wrapper>
            <Wrapper>
              <LabelT2>Avg Freight</LabelT2>
              <Spacer spacing={"1px"} />
              <SelectT1
                isClearable={true}
                options={freightDays}
                // value={freightDays.find((ele) => ele.value === avgFreight)}
                value={avgFreight}
                onChange={handleOnChangeAvgFreight}
              />
            </Wrapper>
            <Wrapper>
              <LabelT2>Vehicle Type</LabelT2>
              <Spacer spacing={"1px"} />
              <SelectT1
                isClearable={true}
                options={vehicleDetails}
                value={vehicleType}
                onChange={handleOnChangeVehicleType}
                isMulti
              />
            </Wrapper>
          </Wrapper> */}
        </FlexWrapperT6>
      </FreightDetailsWrapper>
    </Fragment>
  );
};

export default FreightDetails;

const RateInfoCardT1 = (props) => {
  const {
    isActive,
    isLActive,
    labelOfL,
    rate,
    labelOne,
    labelTwo,
    showRateVariation,
    shouldRenderVehicleName = false,
    vehicleName,
    handleOnClickForVehicleName
  } = props;
  return (
    <Fragment>
      <Td bgColor={!!isActive && "#4E9757"}>
        <RateInfoCard
          rate={rate}
          labelOfL={labelOfL}
          isActive={!!isActive}
          isLActive={isLActive}
          showRateVariation={showRateVariation}
        />
        <Spacer spacing={"3px 0px"} />
        <FlexWrapperT4>
          {!!labelOne && <TypographyT34>{labelOne}</TypographyT34>}
          {!!labelTwo && <TypographyT34>{labelTwo}</TypographyT34>}
        </FlexWrapperT4>
        {shouldRenderVehicleName &&
          <Fragment>
            <Spacer spacing={"3px 0px"} />
            <TypographyT34
              className="cursor-pointer"
              onClick = {
                handleOnClickForVehicleName
              }
            >
              {vehicleName}
            </TypographyT34>
          </Fragment>}
      </Td>
    </Fragment>
  );
};

const FreightDetailsWrapper = styled.div``;

const TableWrapper = styled.div`
  overflow: auto;
  // width: calc(100% - 150px);
  width: 100%;
`;

const Table = styled("table")`
  width: 100%;
  border-spacing: 0px;
  border-radius: 3px;
  box-shadow: 0px 0px 2px 1px #d1d1d1;
`;

const Th = styled("th")`
  padding: 10px;
  background-color: #d4e2fa;
  text-align: left;
  border-top: 1px solid #677586;
  border-bottom: 1px solid #677586;
  border-right: 1px solid #677586;
`;

const THead = styled("thead")`
  & ${Th}:last-of-type {
    border-top-right-radius: 3px;
  }
  & ${Th}:first-of-type {
    border-top-left-radius: 3px;
    border-left: 1px solid #677586;
  }
`;
const TBody = styled("tbody")``;
const Td = styled("td")`
  padding: 10px;
  background-color: ${({ bgColor }) => (!!bgColor ? bgColor : "#f6f9ff")};
  border-bottom: 1px solid rgba(82, 138, 234, 0.45);
  border-bottom: 1px solid #677586;
  border-right: 1px solid #677586;
`;
const Tr = styled("tr")`
  & ${Td}:last-of-type {
    border-bottom-right-radius: 3px;
  }
  & ${Td}:first-of-type {
    border-bottom-left-radius: 3px;
    border-left: 1px solid #677586;
  }
`;
